import React from "react";
import EiqChatPanelAppSync from "./EiqChatPanelAppSync";

export interface EiqChatPanelProps {
  webinarId: string;
  userId: string;
  userName: string;
  userEmail?: string;
  role?: "HOST" | "SPEAKER" | "ATTENDEE";
  organizationId?: string;
  className?: string;
  hideHeader?: boolean;
}

const EiqChatPanel: React.FC<EiqChatPanelProps> = (props) => (
  <EiqChatPanelAppSync {...props} />
);

export default EiqChatPanel;
